module.exports = __webpack_public_path__ + "f41567bf136d7cd89375d24dc4851714.svg";